const s = "작업 시간이 초과되었습니다. 인터넷 연결을 확인하고 다시 시도해 주세요.", e = { 400: "이 이메일 주소는 $t(_company)에 등록되어 있지 않습니다. 올바른지 확인하거나 아래에서 가입해 주세요.", 404: "$t(responses.login.400)", 500: "$t(responses.default)" }, o = { 400: "$t(responses.default)", 500: "$t(responses.default)" }, t = { 2033: "세션을 성공적으로 생성했습니다.", 2064: "세션을 성공적으로 업데이트했습니다." }, n = { 200: "첫 세션을 성공적으로 생성했습니다.", 201: "$t(responses.dashboardSession.200)" }, a = { 2084: "세션 접근 요청이 이미 승인된 상태입니다", 2088: "이미 이 세션에 접근을 요청했습니다.", email: { 200: "사람들이 추가되었습니다" }, domain: { 200: "그룹이 추가되었습니다" } }, r = { 200: "좋습니다! 최신 정보를 알려드리겠습니다." }, c = { 404: "$t(responses.default)", 405: "인증 코드가 정확하지 않습니다. 다시 확인해 주세요.", 500: "$t(responses.default)" }, d = { 500: "죄송합니다, 문제가 발생했습니다. 다시 시도해 주세요.", avatar: { 400: "아바타 저장에 오류가 발생했습니다. 다시 시도해 주세요." } }, i = {
  default: "죄송합니다, 문제가 발생했습니다. 다시 시도해 주세요.",
  timeout: s,
  login: e,
  register: o,
  session: t,
  dashboardSession: n,
  sessionAccess: a,
  subscribe: r,
  verify: c,
  user: d
};
export {
  n as dashboardSession,
  i as default,
  e as login,
  o as register,
  t as session,
  a as sessionAccess,
  r as subscribe,
  s as timeout,
  d as user,
  c as verify
};
